import { render } from "./ChooseMannequinView.vue?vue&type=template&id=491fac32&scoped=true"
import script from "./ChooseMannequinView.vue?vue&type=script&lang=js"
export * from "./ChooseMannequinView.vue?vue&type=script&lang=js"

import "./ChooseMannequinView.vue?vue&type=style&index=0&id=491fac32&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491fac32"]])

export default __exports__